import { useDataChange } from 'Simple/Data'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'steps',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.current_index--
    })
  }
}
